module.exports = __webpack_public_path__ + "01_long_grey.c1588efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_long_grey.png
// module id = Q2GF
// module chunks = 0